const BAYER4 = [0, 8, 2, 10, 12, 4, 14, 6, 3, 11, 1, 9, 15, 7, 13, 5]

let tile

export function ditherTile() {
  if (tile) return tile

  const canvas = document.createElement("canvas")
  canvas.width = canvas.height = 4
  const context = canvas.getContext("2d")
  const image = context.createImageData(4, 4)
  BAYER4.forEach((threshold, index) => {
    const value = Math.round(((threshold + 0.5) / 16) * 255)
    image.data.set([value, value, value, 255], index * 4)
  })
  context.putImageData(image, 0, 0)
  tile = canvas.toDataURL("image/png")
  return tile
}
